<template>
  <div class="winners">
    <h1 v-html="title"></h1>
    <div class="winners-inner">
      <div class="winners-item">
        <div class="winners-position">1</div>
        <div class="winners-place" v-html="place"></div>
        <a href="#" class="winners-name" v-html="firstWinner"></a>
        <div class="winners-gift" v-html="firstGift"></div>
      </div>
      <div class="winners-item">
        <div class="winners-position">2</div>
        <div class="winners-place" v-html="place"></div>
        <a href="#" class="winners-name" v-html="secondWinner"></a>
        <div class="winners-gift" v-html="secondGift"></div>
      </div>
      <div class="winners-item">
        <div class="winners-position">3</div>
        <div class="winners-place" v-html="place"></div>
        <a href="#" class="winners-name" v-html="thirdWinner"></a>
        <div class="winners-gift" v-html="thirdGift"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Winners",
  data() {
    return {
      title: 'Победители:',
      place:'место',
      firstWinner:'@pobegalovsergey',
      secondWinner:'@212km',
      thirdWinner:'@alex__dars',
      firstGift:'ПОЛУЧАЕТ LG gram 17"',
      secondGift:'ПОЛУЧАЕТ LG gram 16"',
      thirdGift:'ПОЛУЧАЕТ LG gram 14"'
    }
  },
}
</script>

<style lang="scss">
@import "winners";
</style>